import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, PenLine, ScanSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';

const HomeClosingChoice: React.FC = () => (
  <section className="border-t border-border/60 bg-muted/20 px-5 py-16 md:px-8 md:py-20" aria-labelledby="closing-choice-title">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-center md:justify-between">
      <div>
        <h2 id="closing-choice-title" className="text-3xl font-medium md:text-4xl">Start where your paper is now.</h2>
        <p className="mt-3 text-muted-foreground">Your unpublished work stays private while you write or review it.</p>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button asChild size="lg">
          <Link to="/write" data-track="closing_start_writing" data-track-category="conversion">
            <PenLine aria-hidden="true" /> Start writing <ArrowRight aria-hidden="true" />
          </Link>
        </Button>
        <Button asChild size="lg" variant="outline">
          <Link to="/upload" data-track="closing_review_paper" data-track-category="conversion">
            <ScanSearch aria-hidden="true" /> Review my paper
          </Link>
        </Button>
      </div>
    </div>
  </section>
);

export default HomeClosingChoice;